import {
  IconCounter,
  Logo,
  ScrollAwareNavbar,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@opositandopn/ui';
import { HiSparkles } from 'react-icons/hi2';
import { IoFlash } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

import { useProfile } from '../../../context/ProfileContext';
import { UserOptions } from './UserOptions';

import styles from './Navbar.module.scss';

function Navbar() {
  const navigate = useNavigate();
  const { profile } = useProfile();

  return (
    <ScrollAwareNavbar className={styles['navbar']}>
      <div className={styles['navbar__content']}>
        <div className={styles['logo-wrapper']} onClick={() => navigate('/')}>
          <Logo className={styles['logo']} variant="logo-h" />
        </div>
        <div className={styles['user']}>
          <div className={styles['icons']}>
            <Tooltip placement="bottom">
              <TooltipTrigger asChild={true}>
                <IconCounter
                  shadow
                  icon={<HiSparkles />}
                  count={profile.ai ?? 0}
                  iconClassName={styles['ai-icon']}
                  format={{
                    notation: 'standard',
                  }}
                />
              </TooltipTrigger>
              <TooltipContent>Tokens disponibles este mes</TooltipContent>
            </Tooltip>
            <Tooltip placement="bottom">
              <TooltipTrigger asChild={true}>
                <IconCounter
                  shadow
                  icon={<IoFlash />}
                  count={profile.credits ?? 0}
                  iconClassName={styles['icon']}
                  format={{
                    notation: 'standard',
                  }}
                />
              </TooltipTrigger>
              <TooltipContent>Puntos obtenidos</TooltipContent>
            </Tooltip>
          </div>
          <UserOptions />
        </div>
      </div>
    </ScrollAwareNavbar>
  );
}

export { Navbar };
